// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clock {\n    display: flex;\n}", "",{"version":3,"sources":["webpack://src/css/Clock.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".clock {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
